import React from 'react';

export const ThemeContext = React.createContext('default');


// WEBPACK FOOTER //
// ./src/constants/theme.jsx